import { applyOverrides } from '@wix/form-conditions';
import { applyNestedFormOverrides } from '@wix/nested-form-overrides';
import { applyNestedForms } from '../../services/apply-nested-forms';
import { applyFormOverrides } from '../../services/form-overrides';
import { omitHiddenValues } from '../../services/omit-hidden-values';
import { validate } from '../../services/validation';
export const validateForm = (formsById, addressTemplates, validationMode)=>({ formId, values, overrides, skipHidden })=>{
        const form = formsById[formId];
        if (!form) {
            console.error('Trying to validate a form that does not exist');
            return;
        }
        const formWithOverrides = applyNestedForms(applyFormOverrides(applyNestedFormOverrides(applyOverrides(form, values)), overrides ?? {}));
        return validate(formWithOverrides, skipHidden ? omitHiddenValues(formWithOverrides, values) : values, addressTemplates, validationMode);
    };

//# sourceMappingURL=validate-form.js.map